"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var rand_1 = require("../rand");
var util_1 = require("../util");
exports.generateStrokedStream = function (_a) {
    var stream = _a.stream;
    return [].concat.apply([], stream.map(function (word, wordIndex) { return __spreadArrays([].concat.apply([], word.map(function (processedCharacter, characterIndex) {
        return processedCharacter.transformed.map(function (character) { return ({
            index: [wordIndex, characterIndex],
            character: character,
            processedCharacter: processedCharacter
        }); });
    })), (stream.length - 1 === wordIndex
        ? []
        : [
            {
                index: [],
                character: " ",
                processedCharacter: {
                    source: " ",
                    transformed: [" "]
                }
            }
        ])); }));
};
exports.generateStrokeTiming = function (options) {
    if (options === void 0) { options = {}; }
    var _a = options.pauseMin, pauseMin = _a === void 0 ? 15 : _a, _b = options.pauseMax, pauseMax = _b === void 0 ? 250 : _b, _c = options.prevCharacter, prevCharacter = _c === void 0 ? null : _c;
    var timing = prevCharacter === " "
        ? // Strokes immediately following spaces tend to be slower
            [pauseMin + 50, pauseMax + 50]
        : [pauseMin, pauseMax];
    return rand_1.range(timing[0], timing[1]);
};
exports.simulateStrokeTiming = function (options) {
    if (options === void 0) { options = {}; }
    return new Promise(function (resolve) {
        return setTimeout(function () { return resolve(); }, exports.generateStrokeTiming(options));
    });
};
exports.simulateTyping = function (_a) {
    var stream = _a.stream, onStroke = _a.onStroke, _b = _a.pauseMin, pauseMin = _b === void 0 ? 15 : _b, _c = _a.pauseMax, pauseMax = _c === void 0 ? 250 : _c;
    return exports.generateStrokedStream({ stream: stream }).reduce(function (promise, stroke, index) {
        return promise.then(function (prevStrokes) {
            var nextStream = __spreadArrays(prevStrokes, [stroke]);
            var previousStroke = prevStrokes[index - 1];
            return new Promise(function (resolve) {
                var maybePromise = onStroke({
                    stroke: stroke,
                    previousStroke: previousStroke,
                    strokedStream: nextStream
                });
                if (util_1.isPromise(maybePromise)) {
                    return maybePromise.then(function () { return resolve(nextStream); });
                }
                return exports.simulateStrokeTiming({
                    pauseMin: pauseMin,
                    pauseMax: pauseMax,
                    prevCharacter: prevStrokes.length && prevStrokes[prevStrokes.length - 1].character
                }).then(function () { return resolve(nextStream); });
            });
        });
    }, Promise.resolve([]));
};
exports.toString = function (strokedStream) {
    return strokedStream.map(function (_a) {
        var character = _a.character;
        return character;
    }).join("");
};
